import { render, staticRenderFns } from "./guessing-rules.vue?vue&type=template&id=809c6f84&scoped=true&"
import script from "./guessing-rules.vue?vue&type=script&lang=js&"
export * from "./guessing-rules.vue?vue&type=script&lang=js&"
import style0 from "./guessing-rules.vue?vue&type=style&index=0&id=809c6f84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809c6f84",
  null
  
)

export default component.exports